<template>
<div class="quizier-module module-quiz module-with-options" :class="{'module-custom' : hasColor}" :style="cssVars" :id="me.index">
    <div class="start-screen" v-if="start === false">
        <div class="screen" @click="start_quiz">
            <img v-if="settings_image" :src="settings_image" class="img-fluid rounded">
            <div class="desc-cont">
                <div class="button">
                    <button class="btn btn-secondary wfit animate__animated animate__pulse btn-large btn-lg animate__infinite" name="button" v-if="start===false">{{ $t('i18n.start_quiz_txt') }}</button>
                </div>
                <div class="description">{{ quiz_description }}</div>
            </div>
        </div>
    </div>
    <div class="animate__fadeInUp animate__animated quiz-container" v-else-if="!end">
        <div class="quiz-header">
            <ul class="q-numb">
                <li v-for="(question, index) in questions" :key="index" :class="[(index <= active_question)? 'active' : '']"></li>
            </ul>
            <div class="q-tot"><span>{{ (active_question + 1) }}</span> / {{ (total_questions + 1) }}</div>
        </div>
        <div class="clearfix"></div>
        <div class="quiz-question">
            <div :style="{ 'background': question_bg }" :class="[ image_preview? 'img-cont' : 'title-cont', {'wfit animate__animated animate__jackInTheBox fast' : !index}, question_class]">
                <h3 class="question-text animate__animated animate__jackInTheBox fast" :class="{wfit : !index}" data-wow-delay="1s" v-for="(question, index) in questions" :key="index" v-if="current_question.id == question.id && question_text != ''"
                  v-html="question_text"></h3>
                <div class="img" v-if="image_preview"><img :src="image_preview" class="img-fluid"></div>
            </div>
            <ul class="choices-cont" :class="[{'q-list' : !is_classic}, choices_count]" v-for="(question, index) in questions" :key="question.id" v-if="current_question.id == question.id">
                <li class="wfit animate__animated fast animate__fadeInUp" @click="log_answer(choice, $event)" :class="[{wfit : !index}, answered? get_answered_class(choice, idx) : '', {'list-btn' : is_classic}]" v-for="(choice, idx) in choices"
                  :key="idx" :style="'animation-delay:'+(0.3+(idx/10))+'s'">
                    <button :class="[{'list' : is_classic}, {'grid' : !is_classic}]">
                        <div class="img-wrapper" :class="{circled : is_circled}" data-aspect-ratio="1:1" v-if="type !== 'classic' && choice.media_path">
                            <div class="img" :style="{ backgroundImage: `url('${choice.media_path}')` }"></div>
                        </div>
                        <div class="choice-text" v-if="!is_classic">{{ choice.title }}</div>
                        <span class="choice-text" v-else>{{ choice.title }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <div class="calculating-results" v-else-if="!has_result">
        <div class="calc_container">
            <div class="results-bg"></div>
            <div class="loading-container">
                <div class="text-wrap">
                    <div class="loader">
                        <div class="lds-hourglass"></div>
                    </div>
                    <div class="text">{{ $t('i18n.calc_results') }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="cta-before-results quiz-result result-screen" v-else-if="has_cta && cta_type === 'form' && cta_form_action === 'before' && !lead_captured">
        <div class="result-txt m-0">
            <div class="text-center mb-3">{{ $t('i18n.unlockResult') }}</div>
            <form-module @lead-captured="leadCaptured" :block_id="me.index" :result="result_id" :post_id="postID" :data="cta_form" />
        </div>
    </div>
    <div class="quiz-result result-screen" v-else>
        <div class="preview" v-if="result_media">
            <img :src="result_media" :alt="result_title" class="img-fluid rounded">
        </div>
        <div class="result-txt description">
            <h3 class="result-title" v-html="result_title"></h3>
            <div class="result-description" v-html="result_desc"></div>
            <div class="result-btn-container" v-if="has_cta && cta_type === 'button'">
                <button-module :block_id="me.index" :result="result_id" :post_id="postID" :button="cta_button" />
            </div>
            <div class="result-form-container" v-if="has_cta && cta_type === 'form' && cta_form_action === 'after'">
                <hr class="my-4">
                <form-module @lead-captured="leadCaptured" :block_id="me.index" :result="result_id" :post_id="postID" :data="cta_form" />
            </div>
            <div class="share-widget mt-3 text-center">
                <div class="share-title">{{ $t('i18n.shareYourResult') }}</div>
                <div class="share-icons mt-2">
                    <ul class="module-share-icons" v-show="social=true">
                        <li><a class="share-button social-button is-twitter"><span v-html="svg('twitter')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-facebook"><span v-html="svg('facebook')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-pinterest"><span v-html="svg('pinterest')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-reddit"><span v-html="svg('reddit')" class="svg-gray svg-24"></span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mixinComponent from '../mixins';
import buttonModule from "../libs/ctaButtonModule.vue";
import formModule from "../libs/ctaFormModule.vue";

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
            uncover: false,
            active_question: 0,
            start: false,
            end: false,
            has_result: false,
            total_questions: null,
            current_question: null,
            social: false,
            lead_captured: false,
        }
    },
    components: {
        buttonModule,
        formModule
    },
    computed: {
        question_class: function () {
            return this.has('question_text_class', false);
        },
        question_bg: function () {
            const $color = this.has('question_bg_color', false);
            if ($color) {
                return this.rgbaToString($color.rgba)
            }
        },
        questions: function () {
            const questions = this.has('questions', []);
            this.total_questions = (questions.length - 1);
            this.current_question = questions[this.active_question] || [];

            return questions;
        },
        settings_image: function () {
            return this.setting(`cover_media_path`, false)
        },
        quiz_description: function () {
            return this.setting('post_description', '')
        },
        image_preview: function () {
            return this.quiz(`media_path`, false)
        },
        question_text: function () {
            return this.quiz(`title`, false)
        },
        choices: function () {
            return this.quiz(`choices`, [])
        },
        answered: function () {
            return this.quiz(`answered`, false)
        },
        choices_count: function () {
            const count = this.quiz(`choices`, []).length
            let className = 'two-columns'
            if (count % 3 == 0) {
                className = 'three-columns'
            } else if (count >= 4) {
                className = 'four-columns'
            }

            return className
        },
        type: function () {
            //media-circle, media-square, classic
            return this.quiz(`question_type`, 'classic')
        },
        is_circled: function () {
            const type = this.quiz(`question_type`, 'classic')
            return type === 'media-circle';
        },
        is_classic: function () {
            const type = this.quiz(`question_type`, 'classic')
            return type === 'classic';
        },
        cssVars: function () {
            const color = this.has('block_colors', false)
            if (color) {
                return {
                    '--block-color': this.rgbaToString(color.rgba)
                }
            }
        },
        hasColor: function () {
            return this.has('block_colors', false)
        },
        result_media: function () {
            return this.result('media_path', false)
        },
        result_title: function () {
            return this.$t('i18n.youGotResult', {
                result: this.result('title', '').replace(/<[^>]*>?/gm, '')
            });
        },
        result_desc: function () {
            return this.result('description', '')
        },
        result_id: function () {
            return this.result('id', '')
        },
        has_cta: function() {
            return this.result('has_cta', false)
        },
        cta_type: function() {
            return this.result('cta_type', false)
        },
        cta_button: function() {
            return this.result('button', {});
        },
        cta_form: function() {
            return this.result('form', {});
        },
        cta_form_action: function() {
            return this.result('form.form_trigger', 'after');
        },
    },
    methods: {
        leadCaptured: function() {
            const $this = this;
            setTimeout(function () {
                $this.lead_captured = true;
            }, ($this.$variables.next_question_time || 2000));
        },
        get_result: function () {
            let results = this.has('results', [])
            results.sort(function (a, b) {
                const aScore = a.score || 0
                const bScore = b.score || 0
                let comparison = 0;
                if (aScore > bScore) {
                    comparison = -1;
                } else if (aScore < bScore) {
                    comparison = 1;
                }
                return comparison;
            });

            const url = this.$variables.results_url;
            if (!url) {
                Quizier.sweetError(this.$t('i18n.somethingWentWrong'));
                return false;
            }

            var action = {};
            action['post_id'] = this.postID;
            action['block'] = this.me.index;
            action['result'] = results[0];
            action['url'] = url;
            if (!this.is_preview) {
                axios.post(url, action).then(res => {
                    if (!res.data.error) {
                        this.has_result = results[0] || []
                    }
                }).catch(err => {
                    this.resetAns(err.response.data.message)
                    return false;
                });
            } else {
                this.has_result = results[0]
            }
        },
        update_score: function (matched) {
            const results = this.has('results', [])

            for (let index in matched) {
                let value = matched[index];

                const resID = Object.keys(results).find(key => results[key].id === index);
                const current_score = this.has(`results.${resID}.score`, '0')
                let score = Number(current_score) + Number(value)
                this._updateValue(`results.${resID}.score`, score)
            }
        },
        start_quiz: function () {
            const questions = this.has('questions', []);
            this.total_questions = (questions.length - 1);
            this.current_question = questions[this.active_question] || [];
            this.start = true
        },
        get_answered_class: function (choice) {
            if (this.quiz('answered', false)) {
                let className = 'disabled';
                if (this.quiz('answered') === choice.id) {
                    className = 'active'
                }

                return className;
            }
        },
        log_answer: function (choice, event) {
            if (!this.quiz('answered', false)) {
                const url = this.$variables.activity_url;
                if (!url) {
                    Quizier.sweetError(this.$t('i18n.somethingWentWrong'));
                    return false;
                }

                var action = {};
                action['post_id'] = this.postID;
                action['block'] = this.me.index;
                action['question'] = this.quiz('id', null);
                action['answered'] = choice.id;
                action['url'] = url;
                this._updateValue(`questions.${this.active_question}.answered`, choice.id)
                if (!this.is_preview) {
                    axios.post(url, action).then(res => {
                        if (!res.data.error) {
                            const matched = choice.matched || []
                            const $this = this;
                            setTimeout(function () {
                                $this.update_score(matched)
                                $this.next()
                                $this.fixScroll()
                            }, ($this.$variables.next_question_time || 500));
                        }

                        if (res.data.error) {
                            this.resetAns(res.data.action.message || false)
                        }
                    }).catch(err => {
                        this.resetAns(err.response.data.message)
                        return false;
                    });
                } else {
                    const matched = choice.matched || []
                    const $this = this;
                    setTimeout(function () {
                        $this.update_score(matched)
                        $this.next()
                        $this.fixScroll()
                    }, ($this.$variables.next_question_time || 500));
                }
            }
        },
        resetAns: function (message = false) {
            this._updateValue(`questions.${this.active_question}.answered`, false)
            if (message) {
                Quizier.sweetError(message)
            }
        },
        next: function () {
            if (this.active_question == this.total_questions) {
                this.end = true
                this.get_result()
            } else if (this.active_question < this.total_questions) {
                this.active_question = this.active_question + 1;
            }
        },
        quiz: function (prop, def) {
            return this.deepget(this.current_question, prop, def);
        },
        result: function (prop, def) {
            return this.deepget(this.has_result, prop, def);
        },
    },
    watch: {
        active_question: function (current, before) {
            const question = this.has(`questions.${current}`);
            this.current_question = question;
        },
        start: function (started, before) {
            if (started) {
                this.fixScroll()
            }
        },
        social: function () {
            const result = {
                id: this.result('id', false),
                title: this.$t('i18n.iGotResult', {
                    result: this.result('title', '')
                })
            }
            Quizier.setupSocial(result);
        }
    }
}
</script>

<style scoped>
.module-custom.module-quiz .btn-secondary,
.module-custom.module-quiz .btn-secondary:hover {
    background-image: none;
    border-color: var(--block-color);
    background-color: var(--block-color);
}

.module-custom.module-quiz ul.choices-cont li.list-btn.active,
.module-custom.module-quiz ul.choices-cont li.list-btn:hover,
.module-custom.module-quiz .quiz-header ul.q-numb li.active,
.module-custom.module-quiz .img-cont .question-text {
    background-color: var(--block-color);
}

.module-custom.module-quiz ul.q-list li.active .img-wrapper,
.module-custom.module-quiz ul.q-list li:hover:not(.disabled) .img-wrapper {
    border-color: var(--block-color);
}

.module-custom.module-quiz ul.q-list li.active .choice-text,
.module-custom.module-quiz ul.q-list li:hover:not(.disabled) .choice-text {
    color: var(--block-color);
}
</style>
